import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Button from "@material-ui/core/Button";
import SweetAlert from "sweetalert2-react";
import Typography from "@material-ui/core/Typography";
import React, { Component } from "react";
import EditarEvento from "./EditarEvento";
import fire from "../config/Fire";

const styles = {
  card: {
    Width: 300,
    height: 320
  },
  media: {
    height: 150,
    width: 300
  }
};

class CartaEventos extends Component {
  constructor(props) {
    super(props);
    // this.setTimeout = this.setTimeout.bind(this);
    // this.reload = this.reload.bind(this);
    this.titulo = props.titulo;
    this.detalle = props.detalle;
    this.link = props.link;
    this.nombreimg = props.nombreimg;
    this.precio = props.precio;
    this.direccion = props.direccion;
    this.fecha = props.fecha;
    this.hashtag = props.hashtag;

    // this.refimage = props.refimage;
    // this.state = {
    //   title: this.props.title,
    // }
    // this.actualizar = props.actualizar;
  }
  componentDidMount() {
    var contenido = this.detalle;
    var titulo = this.titulo;
    var conespacios = titulo.split("-");
    console.log(conespacios[0]);
    if (contenido.length > 50)
      this.setState({ contenido: contenido.substring(0, 50) + "..." });
    else this.setState({ contenido: contenido });
    if (titulo.length > 22)
      this.setState({ titulo: titulo.substring(0, 22) + "..." });
    else this.setState({ titulo: titulo });
  }
  handleClose = () => {
    this.setState({ show: true });
  };

  state = {
    show: false
  };
  //Abre el dialogo para confirmar la eliminación
  confirmarEliminacion() {
    this.setState({ show: true, confirmacion: "Eliminar" });
  }
  eliminar(titulo) {
    this.setState({ show: false });

    fire.auth().onAuthStateChanged(user => {
      if (user) {
        const storageRefImg = fire
          .storage()
          .ref(`/Eventos/${titulo}/${this.nombreimg}`);
        storageRefImg
          .delete()
          .then(function() {
            fire
              .database()
              .ref()
              .child("Eventos")
              .orderByChild("titulo")
              .equalTo(titulo)
              .on("child_added", snapshot => {
                fire
                  .database()
                  .ref()
                  .child("Eventos")
                  .child(snapshot.key)
                  .remove();
              });
            //window.location.reload();
          })
          .catch(function(error) {
            console.log(error);
          });
      }
    });
  }
  render() {
    const { classes } = this.props;
    return (
      <div>
        <Card className={classes.card}>
          <CardActionArea>
            <CardMedia
              className={classes.media}
              image={this.direccion}
              title="Contemplative Reptile"
            />
            <CardContent>
              <Typography gutterBottom style={{ fontSize: "17px" }}>
                {this.state.titulo}
              </Typography>
              <Typography component="p">{this.state.contenido}</Typography>
            </CardContent>
          </CardActionArea>
          <CardActions>
            <Button
              size="small"
              color="primary"
              onClick={() => this.confirmarEliminacion()}
            >
              ELIMINAR
            </Button>
            <EditarEvento
              titulo={this.titulo}
              direccion={this.direccion}
              detalle={this.detalle}
              fecha={this.fecha}
              hashtag={this.hashtag}
              link={this.link}
              nombreimg={this.nombreimg}
              precio={this.precio}
            />
          </CardActions>

          <SweetAlert
            show={this.state.show}
            title="¿Estás seguro?"
            text="No podrás revertir los cambios"
            type="warning"
            showCancelButton={true}
            confirmButtonColor="#3085d6"
            cancelButtonColor="#d33"
            cancelButtonText="Cancelar"
            confirmButtonText={this.state.confirmacion}
            onConfirm={() => this.eliminar(this.titulo)}
          />
        </Card>
      </div>
    );
  }
}

CartaEventos.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(CartaEventos);
